import script from "./CommonAPI.vue?vue&type=script&lang=js"
export * from "./CommonAPI.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__